import { FormattedMessage } from "react-intl";
import { Heading, Text } from "@lendcord/concord";

// Keep this copy generic — no stats, partner names, or license numbers
// have been confirmed for public-facing use yet.
const TRUST_POINT_IDS = [
  "auth.brandPanel.trustPoint1",
  "auth.brandPanel.trustPoint2",
  "auth.brandPanel.trustPoint3",
];

// Desktop-only — the logo that used to also make this visible on mobile now
// lives in AuthHeader instead (shown at every breakpoint), so there's
// nothing left for this panel to usefully show below md:.
export function BrandPanel() {
  return (
    <div className="hidden bg-accent-600 px-12 py-16 text-white md:flex md:w-[45%] md:min-h-dvh md:flex-col md:justify-between">
      <div className="flex flex-col gap-8">
        <div>
          <Heading level={1} className="text-white">
            <FormattedMessage id="auth.brandPanel.heading" />
          </Heading>
          <Text size="lg" className="mt-3 text-white/80">
            <FormattedMessage id="auth.brandPanel.subtitle" />
          </Text>
        </div>

        <ul className="flex flex-col gap-3">
          {TRUST_POINT_IDS.map((id) => (
            <li key={id} className="flex items-center gap-3 text-sm text-white/90">
              <span
                className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white/15 text-xs"
                aria-hidden="true"
              >
                ✓
              </span>
              <FormattedMessage id={id} />
            </li>
          ))}
        </ul>
      </div>

      <div aria-hidden="true" />
    </div>
  );
}
